import { withInstall } from '@vuemap/vue-amap-util'
import CircleMarker from './CircleMarker.vue'

export const ElAmapCircleMarker = withInstall(CircleMarker)
export default ElAmapCircleMarker
